import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TitleModal from "../components/common/titleModal";
import ButtonSubmit from "../components/common/buttonSubmit";
import { useVerifyDoctorMeeting } from "../hooks/useMeeting";
import { getAxiosTranslatedError } from "../utils/helpers";
import MeetingBox from "../components/meetingBox";
import TelemedicinePage from "../components/telemedicinePage";
import Countdown from 'react-countdown';

function TelemedicineDoctor() {
  const { t } = useTranslation()
  const navigate = useNavigate();

  const { doctorToken = '' } = useParams()

  const { mutate: verifyDoctorMeeting } = useVerifyDoctorMeeting()

  const [meeting, setMeeting] = useState<any>()
  const [errorMessage, setErrorMessage] = useState('')

  const [showCounter, setShowCounter] = useState(true)
  const [showConfirm, setShowConfirm] = useState(false)

  function verifyToken() {
    verifyDoctorMeeting(
      { token: doctorToken },
      {
        onSuccess: ({ meeting }) => {
          setMeeting(meeting)
        },
        onError: (error: any) => {
          setErrorMessage(getAxiosTranslatedError(error))
        },
      }
    )
  }


  function handleStartVisit() {
    navigate(`/telemedicine/meeting/${doctorToken}`)
  }

  function handleCountDownEnd() {
    setShowCounter(false)
    setShowConfirm(true)
  }

  useEffect(() => {
    verifyToken()
  }, [])

  const renderer = (
    { days,
      hours,
      minutes,
      seconds,
      completed
    }: {
      days: number,
      hours: number,
      minutes: number,
      seconds: number,
      completed: boolean
    }) => {

    if (completed) {
      return null;
    } else {

      const totalHours = (days * 24) + hours;
      return (
        <div className="countdown-container">
          <div className="time-block">
            <div className="circle">{totalHours}</div>
            <span className="label">{t('hours')}</span>
          </div>

          <div className="time-block">
            <div className="circle">{minutes}</div>
            <span className="label">{t('minutes')}</span>
          </div>

          <div className="time-block">
            <div className="circle">{seconds}</div>
            <span className="label">{t('seconds')}</span>
          </div>
        </div>
      );
    }
  };


  const Counter = <>
    {meeting && <>
      <MeetingBox meeting={meeting} />
      <Countdown
        date={new Date(meeting.startDate)}
        renderer={renderer}
        onComplete={handleCountDownEnd}
      />
    </>}
  </>

  const Confirm = <>
    <TitleModal title={t("telemedicine-join.confirmed-meeting-title")} />
    <TitleModal title={t("telemedicine-join.confirmed-meeting-title2")} />

    {meeting && <MeetingBox meeting={meeting} />}

    <div className="mt-4">
      <ButtonSubmit
        className="btnMeeting"
        textButton={t("telemedicine-join.start-visit")}
        handleChange={() => handleStartVisit()}
      />
    </div>
  </>

  return (
    <TelemedicinePage>
      {showCounter && Counter}
      {showConfirm && Confirm}
      {errorMessage && (
        <div className="warning-box mt-2">
          <span className="material-icons warning-icon-size text-warning">
            warning
          </span>
          <span className="warning-text-size text-warning ms-2">
            {errorMessage}
          </span>
        </div>
      )}
    </TelemedicinePage>
  );
}

export default TelemedicineDoctor;
